<template>
  <v-row
    v-if="Array.isArray(backendFiles)"
    class="images-uploaded"
    :style="{padding: padding + 'px' }"
  >
    <draggable
      :list="internalFiles"
      :options="{disabled: false}"
      tag="div"
      class="btn--container p-0"
      style="width: 100%;"
      @change="$emit('reorder', internalFiles)"
    >
      <div
        v-for="(file, index) in internalFiles"
        :key="index"
        class="file-card"
      >
        <div class="file-card">
          <div
            v-if="showThumbnail"
            class="image-frame"
          >
            <img
              :src="fileBlobUrls[file.id]"
              alt="thumbnail"
              class="image-thumbnail"
            >
          </div>

          <div class="file-actions">
            <v-icon
              v-if="!preview"
              color="#26384B"
              big
              :disabled="forceDisableRemove || disabled"
              @click="$emit('removeFiles', file.id || file._id)"
            >
              mdi-close
            </v-icon>
            <v-btn
              text
              outlined
              small
              class="ma-1 file-name-btn"
              style="border: none !important; font-weight: 400; font-style: italic;margin: 0px"
              :disabled="disabled"
              :title="file.link ? file.link.fileName : file.fileName || file.title || ''"
              @click="downloadFile(file)"
            >
              {{ getShortFileName(file.link ? file.link.fileName : '') }}
            </v-btn>
          </div>
        </div>
      </div>
    </draggable>
    <v-col v-if="loading" class="d-flex align-center justify-center" style="height: 200px;">
      <v-progress-circular size="32" indeterminate color="primary" />
    </v-col>
  </v-row>
</template>
<script>
import draggable from 'vuedraggable';

export default {
    components: {
        draggable,
    },
    props: {
        backendFiles: {
            type: Array,
            default: () => ([]),
        },
        preview: {
            type: Boolean,
            default: false,
        },
        padding: {
            type: Number,
            default: 0,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        dataCy: {
            type: String,
            default: '',
        },
        forceDisableRemove: {
            type: Boolean,
            default: false,
        },
        onDownloadFile: {
            type: Function,
            default: null,
        },
        showThumbnail: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fileBlobUrls: {},
            internalFiles: [],
        };
    },
    watch: {
        backendFiles(newVal) {
            this.internalFiles = [...newVal];
        },

        internalFiles: {
            immediate: true,
            handler(files) {
                if (!Array.isArray(files)) return;
                files.forEach(file => {
                    if (file && file.id && !this.fileBlobUrls[file.id]) {
                        this.fetchBlobUrl(file);
                    }
                });
            },
        },
    },
    methods: {
        async downloadFile(file) {
            if (this.onDownloadFile) {
                this.onDownloadFile(file);
            } else {
                const { data } = await this.$rq.downloadFile(file.id);
                this.$utils.saveFileOnDisk(data, file.link.fileName || file.fileName);
            }
        },
        isImageFile(file) {
            const name = (file.link?.fileName || '').toLowerCase();
            return name.endsWith('.png') || name.endsWith('.jpg') || name.endsWith('.jpeg') || name.endsWith('.svg');
        },
        async fetchBlobUrl(file) {
            const blob = await this.$rq.getFileUrl(file.id);
            if (blob instanceof Blob) {
                this.$set(this.fileBlobUrls, file.id, URL.createObjectURL(blob));
            } else if (typeof blob === 'string') {
                this.$set(this.fileBlobUrls, file.id, blob);
            }
        },
        getShortFileName(name) {
            if (!name) return '';
            const max = 20;
            if (name.length <= max) return name;
            const extMatch = name.match(/(\.[^.]*)$/);
            const ext = extMatch ? extMatch[1] : '';
            const base = name.replace(ext, '');
            // Always show the start and extension, hide the middle
            const visibleChars = max - ext.length - 3; // 3 for '...'
            return `${base.slice(0, visibleChars)}...${ext}`;
        },
    },
};
</script>
<style scoped>
  .btn--container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  box-sizing: border-box;
}
  ::v-deep .v-btn:not(.v-btn--round).v-size--small {
    height: auto;
  }
  .file-card {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  width: auto;
  min-width: 120px;
  max-width: 200px;
  margin: 0;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
}


.file-actions {
  width: 100%;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  box-sizing: border-box;
  border-radius: 5px;
  border: 0.1px solid #26384B;
  margin-top: 5px;
}
.image-frame, .file-actions {
  width: 100%;
  min-width: 0;
  max-width: 200px;
}
.image-frame {
  height: 13vw;
  min-height: 60px;
  max-height: 150px;
  background: #fff;
  border: 2px solid #e0e0e0;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.image-thumbnail {
  width: 100%;
  height: auto;
  max-width: 100%;
  max-height: 100%;
}
.file-name-btn {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 1;
  text-align: left;
  justify-content: flex-start !important;
}
</style>
